import Resolution from 'engine/Resolution.js';

export const INFO_COLUMN_WIDTH = 140;
export const RIGHT = 'RIGHT';
export const LEFT = 'LEFT';
export const DEFAULT_RESOLUTION = new Resolution(16, false);
